module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('site-header'), _vm._v(" "), _c('main', [(_vm.item) ? _c('article', {
    staticClass: "wrap",
    class: _vm.$style.post
  }, [_c('header', {
    class: _vm.$style.header
  }, [_c('h1', {
    class: _vm.$style.title,
    domProps: {
      "innerHTML": _vm._s(_vm.item.title.rendered)
    }
  }), _vm._v(" "), _c('p', {
    class: _vm.$style.meta,
    domProps: {
      "innerHTML": _vm._s(_vm.item.acf.description)
    }
  })]), _vm._v(" "), _c('div', {
    class: _vm.$style.body
  }, [(_vm.item.acf.vimeo_url) ? _c('figure', [_c('iframe', {
    attrs: {
      "src": _vm.getVimeoUrl,
      "width": "640",
      "height": "360",
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.content.rendered)
    }
  })])]) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e60952fe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Work.vue
// module id = 122
// module chunks = 2